export default {
  onUpdate: async (registration) => {
    const cacheKeys = await caches.keys();
    await Promise.all(cacheKeys.map((key) => caches.delete(key)));
    await registration.unregister();
    window.location.reload();
  },
};
